import React from "react";

const Footer = () => (
  <footer className="footer mt-auto">
    <div className="container-fluid"></div>
  </footer>
);

export default Footer;
